import { z } from 'zod';

export const feedbackSchema = z.object({
  rating: z
    .number({ invalid_type_error: 'Please select a rating' })
    .int()
    .min(1, { message: 'Please select a rating' })
    .max(5, { message: 'Rating must be between 1 and 5' }),
  message: z
    .string()
    .trim()
    .min(10, { message: 'Please share at least 10 characters' })
    .max(1000, { message: 'Feedback must be less than 1000 characters' }),
});

export type FeedbackFormData = z.infer<typeof feedbackSchema>;
